import * as yup from "yup";
export const CreateQuerySchema = yup.object().shape({
  queryRaised: yup.string(),
  relatedTo: yup.string().required("Required"),
  message: yup.string().required("Required"),
  generatedBy: yup.string(),
  image: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  assignedName: yup.string(),
});
